import { env } from '@/config';
import { addTrack, TRACK_TYPE } from '@/business/spider/track';

const URLS = {
  TEST: 'https://oss.5rs.me/oss/uploadfe/png/7a5752d7654b8253e333ad05fac65b37.png',
  UAT: 'https://oss.5rs.me/oss/uploadfe/png/c0187d932a656816d6447b78181041a8.png',
  PRO: 'https://oss.5rs.me/oss/uploadfe/png/2dd924393e90d0a3118ce418bddcf8aa.png'
};

// 英语数学一样
const COMM_OPTIONS = [
  {
    value: 1,
    section: [1, 3],
    label: '1-3年级'
  },
  {
    value: 5,
    section: [4, 6],
    label: '4-6年级'
  }
];

export const DEFAULT_SUBJECT = [
  {
    subjectName: '语文',
    subjectTags: [
      {
        value: 1,
        section: [1, 2],
        label: '1-2年级'
      },
      {
        value: 3,
        section: [3, 4],
        label: '3-4年级'
      },
      {
        value: 5,
        section: [5, 6],
        label: '5-6年级'
      }
    ]
  },
  {
    subjectName: '数学',
    subjectTags: COMM_OPTIONS
  },
  {
    subjectName: '英语',
    subjectTags: COMM_OPTIONS
  }
];

export const GET_SHARE_IMAGES = () => {
  return URLS[env];
};

// 公共埋点
// 详细见文档 https://doc.weixin.qq.com/sheet/e3_AagA4wZLAHkNu3TNrT3Tj65lIqQmY
export const leaTrack = (typeCode) => {
  addTrack({
    type: TRACK_TYPE.CLICK,
    spm: '4215',
    subSpm: typeCode
  });
};

// 分享好友模板
export const getPosterTemplate = ({ userNum }) => {
  const width = 750;
  const height = 1624;
  const shareUrl = GET_SHARE_IMAGES();
  const htmlCode = `<!DOCTYPE html>
  <html lang="en">
  <head>
    <meta charset="GBK">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <style>
      * {
        margin: 0;
        padding: 0;
      }
      .poster {
        position: relative;
        width: ${width}px;
        height: ${height}px;
        background-image: url('https://oss.5rs.me/oss/uploadfe/png/98880393c66f35fe53a50b58a402f6bf.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .poster-user {
        position: absolute;
        top: 458px;
        left: 84px;
        color: #fff;
        font-size: 28px;
        font-weight: bold;
        font-family: Arial, sans-serif;
      }
      .poster-qrcode {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 140px;
        width: 288px;
        height: 288px;
        border-radius: 24px;
      }
    </style>
  </head>
  <body>
    <div class="poster">
     <div class="poster-user">${userNum}人测过</div>
     <img class="poster-qrcode" src="${shareUrl}"></img>
    </div>
  </body>
  </html>`;
  return {
    width,
    height,
    htmlCode
  };
};

// 生成海报模板
export const getShareTemplate = ({ canvasURL, userName, learnScore, learnLabel, learnColor, learnPercent, ...props }) => {
  const width = 750;
  const height = 2856;
  const shareUrl = GET_SHARE_IMAGES();
  let adviseHTML = '';
  if(props.minAdvise || props.maxAdvise) {
    if(props.maxAdvise) {
      adviseHTML += `<div class="box-desc">${props.maxAdvise}</div>`;
    }
    if(props.minAdvise) {
      adviseHTML += `<div class="box-desc">${props.minAdvise}</div>`;
    }
  } else {
    adviseHTML += `<div class="box-desc">${props.balanceAdvise}</div>`;
  }
  const htmlCode = `<!DOCTYPE html>
  <html lang="en">
  <head>
    <meta charset="GBK">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <style>
    *{
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }
    .poster {
      width: ${width}px;
      height: ${height}px;
      background-image: url('https://oss.5rs.me/oss/uploadfe/png/168c25a7d6bf50204d73bdf016bd13fd.png');
      background-repeat: no-repeat;
      background-size: 100% auto;
      padding: 0 32px;
      background-color: #FFF8F1;
    }
    .poster-title {
      color: #D66D07;
      font-size: 48px;
      font-weight: bold;
      padding: 40px 0 20px;
      text-align: center;
    }
    .poster-index {
      height: 1144px;
      box-shadow: 0px 8px 24px 0px rgba(121, 83, 16, 0.1);
      background-color: #fff;
      border-radius: 40px;
      margin-top: -236px;
      padding-top: 266px;
    }
    .poster-index-medal {
      position: relative;
      display: block;
      margin: 0 auto;
      width: 616px;
      height: 392px;
      background-image: url('https://oss.5rs.me/oss/uploadfe/png/560b322606e839d043704585bf03c5b3.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      z-index: 1;
      padding-top: 118px;
      --title-color: #EA9023;
      --score-color: #764403;
      --bgBefor-color: #FF5D00;
      --bgAfter-color: #FFDB23;
    }
    .poster-index-medal.is-primary {
      background-image: url('https://oss.5rs.me/oss/uploadfe/png/5ffcb2b649fae3e62228141300796318.png');
      --title-color: #BE4C2F;
      --score-color: #781900;
      --bgBefor-color: #FF454A;
      --bgAfter-color: #FFAA95;
    }
    .poster-index-medal.is-success {
      background-image: url('https://oss.5rs.me/oss/uploadfe/png/8b10c5c68cd7a8c423fb4cf9eaf98cdb.png');
      --title-color: #8284A2;
      --score-color: #2A2B3E;
      --bgBefor-color: #6C79FF;
      --bgAfter-color: #8E55E2;
    }
    .medal-title {
      color: var(--title-color);
      font-size: 32px;
      font-weight: 600;
      text-align: center;
    }
    .medal-score {
      color: var(--score-color);
      font-size: 112px;
      text-align: center;
      line-height: 112px;
      font-family: Arial, sans-serif;
    }
    .medal-tag {
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      height: 78px;
      line-height: 78px;
      background: linear-gradient(180deg, var(--bgBefor-color) 0%, var(--bgAfter-color) 100%);
      border-radius: 78px;
      color: #fff;
      font-size: 39px;
      padding: 0 32px;
      font-weight: 600;
    }
    .poster-index-user {
      text-align: center;
      color: #333;
      font-size: 28px;
      font-weight: 600;
      line-height: 40px;
    }
    .poster-index-desc {
      text-align: center;
      font-size: 28px;
      color: #999;
      line-height: 40px;
      margin: 8px 0 100px;
    }
    .poster-index-desc > span {
      color: #E6540B;
      margin: 0 8px;
      font-weight: 600;
      font-family: Arial, sans-serif;
    }
    .poster-index-radar {
      display: block;
      width: 100%;
    }
    .poster-card {
      position: relative;
      margin-top: 40px;
      padding-top: 16px;
    }
    .card-title {
      position: absolute;
      top: 0;
      left: 32px;
      display: flex;
      align-items: center;
      padding: 0 24px;
      height: 60px;
      border-radius: 8px;
      background-color: #FFB218;
      box-shadow: 0px 8px 32px 0px rgba(135, 56, 14, 0.2);
      color: #fff;
      font-size: 32px;
      font-weight: bold;
    }
    .card-box {
      background-color: #fff;
      border-radius: 40px;
      overflow: hidden;
      padding-bottom: 32px;
    }
    .card-box::before {
      display: block;
      content: '';
      width: 100%;
      height: 80px;
      background: linear-gradient(180deg, #FFEED2 0%, rgba(255,255,255,0.00) 100%);
    }
    .card-box > div {
      padding: 0 32px;
    }
    .box-title {
      font-size: 28px;
      color: #666;
      line-height: 44px;
    }
    .box-subtitle {
      font-size: 40px;
      font-weight: bold;
      margin: 8px 0 16px;
    }
    .box-subtitle > span {
      color: #1F92FF;
      margin-left: 8px;
    }
    .box-subtitle > .is-success {
      color: #28BC4F;
    }
    .box-subtitle > .is-danger {
      color: #E6540B;
    }
    .box-subtitle > .is-warning {
      color: #FFB218;
    }
    .box-desc {
      color: #999;
      font-size: 28px;
      line-height: 44px;
      margin-bottom: 16px;
      white-space: pre-wrap;
    }
    .box-desc:last-child {
      margin-bottom: 0;
    }
    .poster-share {
      display: flex;
      background-color: #fff;
      border-radius: 40px;
      margin-top: 40px;
      padding: 32px;
    }
    .poster-share-img {
      width: 160px;
      height: 160px;
      display: block;
    }
    .poster-share-info {
      flex: 1 1;
      margin-left: 24px;
    }
    .info-title {
      color: #333;
      font-size: 32px;
      line-height: 44px;
      font-weight: bold;
    }
    .info-tags {
      display: flex;
      align-items: center;
      color: #999;
      font-size: 28px;
      margin: 8px 0 32px;
    }
    .info-tags > i {
      margin: 0 16px;
      width: 2px;
      height: 24px;
      background-color: #999;
    }
    .info-desc {
      width: 288px;
      height: 32px;
      background-image: url('https://oss.5rs.me/oss/uploadfe/png/a5b70d1e08d96c18dd20ea3e84ab8519.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    </style>
  </head>
  <body>
    <div class="poster">
      <div class="poster-title">${props.subjectName}学习力分析报告</div>
      <div class="poster-index-wrapper">
        <div class="poster-index-medal is-${learnColor}">
          <div class="medal-title">学习力指标</div>
          <div class="medal-score">${learnScore}</div>
          <div class="medal-tag">${learnLabel}</div>
        </div>
        <div class="poster-index">
          <div class="poster-index-user">${userName}</div>
          <div class="poster-index-desc">您的学习力超过了<span>${learnPercent}%</span>的同龄人</div>
          <img class="poster-index-radar" src="${canvasURL}" />
        </div>
      </div>
  
      <div class="poster-card">
        <div class="card-title">发展建议</div>
        <div class="card-box">
          <div class="box-title">本次测试结果显示你的</div>
          <div class="box-subtitle">${props.subjectName}学习力整体表现 <span class="is-${props.scoreColor}">${props.scoreGrade}</span></div>
          <div class="box-desc">${props.overallDimensions}</div>
          <div class="box-desc">${props.scoreAnalysis}</div>
          ${adviseHTML}
          <div class="box-desc">${props.commonAdvise}</div>
        </div>
      </div>
  
      <div class="poster-share">
        <img class="poster-share-img" src="${shareUrl}" />
        <div class="poster-share-info">
          <div class="info-title">测测孩子的学习潜力</div>
          <div class="info-tags">麻省理工学院<i></i>专业学习力模型</div>
          <div class="info-desc"></div>
        </div>
      </div>
    </div>
  </body>
  </html>`;
  return {
    width,
    height,
    htmlCode
  };
};